import eventBus from '@/js/eventBus.js';
import Modal from '@/components/admin/Modal';

export default {
  components: {
    Modal
  },
  methods: {
    showSuccessMessage (msg) {
      const succesMsg = {
        message: msg
      }
      eventBus.$emit('info', succesMsg)
    },
    confirmAction (callback, question, button = "Delete", cancelCallback) {
      const obj = {
        okButton: button,
        title: question,
        okCallback: callback,
        cancelCallback: cancelCallback,
      };
      eventBus.$emit("confirm", obj);
    },
  }
}